/**
 * The order several places go into one part of a day when they're added
 * together from the map's "Select places" tray (Kurtis 2026-10-23): no times,
 * so the order is the only route the day has — nearest-neighbour from the
 * stop before the block, so the day's pin numbers trace a sensible loop
 * instead of the order they were tapped.
 *
 * Pure — no React, no i18n, no map.
 */
import { getTimeBlock } from './activityUtilities';
import { distanceMeters } from './tourWalkability';

const BLOCK_ORDER = { all_day: 0, morning: 1, afternoon: 2, evening: 3 };

const pointOf = (x) => {
  const c = x?.coordinates || (x?.lat != null && x?.lng != null ? { lat: x.lat, lng: x.lng } : null);
  const lat = Number(c?.lat), lng = Number(c?.lng);
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

/**
 * Where the walk starts: the last stop with a position at or before `block`
 * on the day (its existing order), or null. All-day stops don't count.
 */
export function anchorForBlock(dayActivities = [], block = 'afternoon') {
  const limit = BLOCK_ORDER[block] ?? 2;
  let anchor = null;
  (dayActivities || []).forEach((a) => {
    const b = getTimeBlock(a);
    if (b === 'all_day' || (BLOCK_ORDER[b] ?? 1) > limit) return;
    const p = pointOf(a);
    if (p) anchor = p;
  });
  return anchor;
}

/**
 * `items` reordered nearest-first from `start` ({lat, lng} or null — then the
 * first item with a position starts). Items without a position keep their
 * relative order at the end. Returns a new array; never drops an item.
 */
export function orderByNearest(items = [], start = null) {
  const placed = [];
  const unplaced = [];
  (items || []).forEach((it) => (pointOf(it) ? placed : unplaced).push(it));
  const out = [];
  let here = start && pointOf(start) ? pointOf(start) : null;
  const left = placed.slice();
  while (left.length) {
    let best = 0;
    if (here) {
      let bestD = Infinity;
      for (let i = 0; i < left.length; i++) {
        const d = distanceMeters(here, pointOf(left[i]));
        if (d < bestD) { bestD = d; best = i; }
      }
    }
    const [next] = left.splice(best, 1);
    out.push(next);
    here = pointOf(next);
  }
  return out.concat(unplaced);
}
